import { ProtocolFilterData, SelectedFilter } from './../dashboard/overview-dashboard/dashboard-info';
import { SampleTrackerData, StudyGroupInfo } from './../group-info/study-group-info';
import { IFilterSelectItem } from '../shared/sample-tracking-select/sample-tracking-select.component';
import * as moment from 'moment';
import { dataMember, typedArray } from 'santee-dcts';
import { deserializers } from '../../core';
import { DateRangeFilterValue } from '../../shared/time-frame-filter/timeframe-filter.component';

export class FilterSamplesInfo {
    public filterData: ProtocolFilterData[];
    public selectedFilterItems: SelectedFilter[] = [];
    public selectedProtocol$?: SampleTrackerData;
    public selectedStudyGroup?: StudyGroupInfo;
    public selectedStatus: IFilterSelectItem;
    public selectedDateRange?: DateRangeFilterValue;
}

export class SamplesGridRequestInfo {
    public sampleType?: number;
    public protocolId?: number[];
    public protocolData?: ProtocolData[];
    public protocolCode?: string[];
    public subprotocolId?: number[];
    public projectNumber?: string[];
    public countryId?: number[];
    public countryName?: string[];
    public investigatorSiteId?: number[];
    public investigatorNumber?: string[];
    public protocolVisitCode?: number[];
    public fromDate?: moment.MomentInput;
    public toDate?: moment.MomentInput;
    public sponsorName?: string[];
    public isOnHoldListData?: boolean;
    public region?: string[];
    public timeFrameFilterColumn: string;
}

export class ProtocolData {
    public protocolId?: number;
    public protocolCode?: string;
}

export interface GroupTrackingGridData {
    sponsorName: string;
    projectNumber: string;
    protocolVisitCode: string;
    protocolVisitDescription: string;
    protocolCode: string;
    protocolId: number;
    subprotocolId: number;
    investigatorSiteId: number;
    countryId: number;
    countryName: string;
    investigatorNumber: string;
    investigatorName: string;
    accessionId: number;
    accessionNumber: string;
    containerId: number;
    containerNumber: number;
    barcode: string;
    parentBarcode: string;
    sampleStatus: string;
    kitReceivedDate: any;
    containerReceivedDate: any;
    specimenCollectionDate: any;
    kitReceivedTime: any;
    containerReceivedTime: any;
    specimenCollectionTime: any;
    expectedReceiptCondition: string;
    containerLabel1: string;
    containerLabel2: string;
    screeningNumber: string;
    patientNumber: string;
    daysPendingReceipt: number;
    notification1SentTo: string;
    notification2SentTo: string;
    notification3SentTo: string;
    notification1Sent: any;
    notification2Sent: any;
    notification3Sent: any;
    notification1SentTime: any;
    notification2SentTime: any;
    notification3SentTime: any;
    expectedReturnState: string;
    actualReceiptCondition: string;
    sampleRegisteredDate: any;
    sampleRegisteredTime: any;
    shippedToLocation: string;
    shippedFromLocation: string;
    shippedDate: any;
    shippedTime: any;
    airwayBillNumber: string;
    specimenClassDescription: string;
    specimenClass: string;
    cancelDescription: string;
    sampleLocation: string;
    containerBarCode: string;
    shipmentCourier: string;
    shippedToOrganizationName: string;
    shipmentStatus: string;
    scheduledShipmentDate: any;
    shipmentSubmittedDate: any;
    shipmentCreatedDate: any;
    scheduledShipmentTime: any;
    shipmentSubmittedTime: any;
    shipmentCreatedTime: any;
    shippedTo: number | null;
    specimenType: string;
    expirationDate: any;
    effectiveDate: any;
    eQueryOpenDate: any;
    eQueryOpenTime: any;
    daysOpen: string;
    eQueryType: string;
    samplesEffectedByQuery: string;
    region: string;
    expandData?: { child: GroupTrackingGridData[], parent: GroupTrackingGridData[] };
    cssClass?: string;
    childDataForDownload?: string[];
    parentDataForDownload?: string[];

    accessionid: number;
    zcprojectnumber: string;
    kit_type_desc: string;
    code: string;
    protocolid: number;
    subprotocolid: number;
    investigatorsiteid: number;
    countryid: number;
    name: string;
    investigator_number: string;
    investigatorname: string;
    accessionnumber: string;
    containerid: number;
    container_number: number;
    sample_status: string;
    kit_received_on: any;
    kit_received_on_time: any;
    sample_received_on: any;
    sample_received_on_time: any;
    specimencollectedon: any;
    specimencollectedon_time: any;
    expected_condition: string;
    label1: string;
    label2: string;
    screeningnumber: string;
    patientnumber: string;
    dayspendingreceipt: number;
    notification1sentto: string;
    notification2sentto: string;
    notification3sentto: string;
    notification1sent: any;
    notification2sent: any;
    notification3sent: any;
    receiptcondition: string;
    protocolvisitcode: string;
    sampleregistereddate: any;
    sampleregistereddate_time: any;
    canceldescription: string;
    sampletype: string;
    visit_name: string;
    specimenclassDesc: string;
    specimenclass: string;
    subprotocol_region: string;
    investigatorsiteshipment_trackingnumber: string;
    investigatorsiteshipment_createdon: any;
    investigatorsiteshipment_submittedon: any;
    investigatorsiteshipment_shipmentplannedfor: any;
    investigatorsiteshipment_createdon_time: any;
    investigatorsiteshipment_submittedon_time: any;
    investigatorsiteshipment_shipmentplannedfor_time: any;
    investigatorsiteshipment_courier: string;
    investigatorsiteshipment_toorganizationname: string;
    specimentype: string;
    daysopen: number;
    shippedon: any;
    shippedtoorg: string;
    trackingnumber: string;
    equerytype: string;
    equeryopendate: string;
    equeryopenTime: string;
    sponsorBlindedSamplesEffectedByQuery: number;
    investigatorBlindedSamplesEffectedByQuery: number;
    protocolBlinding: string;
    expectedreturnstate: string;
    investigatornamematch?: string;
    investigatorsitenumbermatch?: string;
    pvcmatch?: string;
    visitnamematch?: string;
    missMatches?: MissMatch[];
    returntype: String;
    reason_not_available: string;
    lgxShipmentId?: String;

    visit_description?: String;
    investigatorsite_country?: String;
    protocol_code?: string;
}

export interface MissMatch {
    columnName: string;
}

export interface DynamicListRequestInfo {
    dB_View_Name: string;
    viewNaturalKey: string;
    dB_View_Column_Name: string[];
    whereFilter: QueryFilter[];
    joinTableFilter?: ColumnInfo[];
    customSql?: ColumnInfo[];
}

export interface ColumnInfo {
    dbViewColumnName?: string;
    displayName?: string;
    physicalEntity?: string;
    physicalEntityAttribute?: string;
    entityAttribute?: string;
    customSQL?: string;
}

export interface QueryFilter {
    filterName: string;
    value: string;
    operator: string;
}

export enum Operator {
    in = 'in',
    equal = 'equal',
    between = 'between',
    and = 'and'
}

export interface DataRevisionInfo {
    sstInvestigatorNumber?: string;
    zcInvestigatorNumber?: string;
    sstInvestigatorName?: string;
    zcInvestigatorName?: string;
    sstVisitDescription?: string;
    zcVisitDescription?: string;
    sstProtocolVisitCode?: string;
    submittedOn?: string;
    zcProtocolVisitCode?: string;
}